import { Result } from './../models/Result.model';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { Approval } from "../models/Approval.model";
import { ApprovalsSearch } from "../models/ApprovalsSearch.models";
import { UrlBuilder } from "../models/utils/url-builder.model";
import * as _ from 'lodash';
import * as bluebird from 'bluebird';

@Injectable()
export class ApprovalService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/approvals";
    multiApprovals: any = [];

    create(approvals) {
        let responses = [];
        approvals.forEach(element => {
            element.consultant.companyName = element.consultant.contract.kind == 1 ? element.consultant.contract.companyName : '';
            element.consultant.contract = null;
        });

        return bluebird.map(approvals, (approval)=>{ return this.httpClient.post(this.endPoint, _.cloneDeep(approval))},{concurrency: 20});

        // for(let approval of approvals){
        //     responses.push(await this.httpClient.post(this.endPoint, _.cloneDeep(approval)));
        // }


    }

    async update(approval:Approval){
        let id = approval._id;
        return await this.httpClient.update(this.endPoint,id,approval)
    }

    async getApproval(_id:String){
        return await this.httpClient.get(`${this.endPoint}/${_id}`)
    }

    async getHashtrackApprovals(username){
        let body = {username:username};
        let response = await this.httpClient.post(`${this.endPoint}/hashtrack`,body);
        return response;
    }

    async search(approvalsSearch): Promise<Approval[]> {

        const builder = new UrlBuilder([
            { key: "skip", value: approvalsSearch.skip },
            { key: "limit", value: approvalsSearch.limit }
        ]);

        var keyValueParams = [];

        for (let subdivision of approvalsSearch.subDivisions)
            keyValueParams.push({ key: "subDivision", value: subdivision });

        for (let statusApproval of approvalsSearch.statusApprovals)
            keyValueParams.push({ key: "statusApprovals", value: statusApproval });

        for (let statusInvoice of approvalsSearch.statusInvoices)
            keyValueParams.push({ key: "statusInvoices", value: statusInvoice });

        for (let contract of approvalsSearch.contracts)
            keyValueParams.push({ key: "contracts", value: contract });

        for (let projectId of approvalsSearch.projects)
            keyValueParams.push({ key: "projects", value: projectId });

        for (let consultantId of approvalsSearch.consultants)
            keyValueParams.push({ key: "consultants", value: consultantId });

        for (let companyId of approvalsSearch.companies)
            keyValueParams.push({ key: "companies", value: companyId });

        for (let responsibleId of approvalsSearch.responsibles)
            keyValueParams.push({ key: "responsibles", value: responsibleId });

        for (let year of approvalsSearch.years)
            keyValueParams.push({ key: "year", value: year });

        for (let month of approvalsSearch.months)
            keyValueParams.push({ key: "month", value: month });

        for (let industryId of approvalsSearch.industries)
            keyValueParams.push({ key: "industries", value: industryId });

        for (let excellenceCenterId of approvalsSearch.excellenceCenters)
            keyValueParams.push({ key: "excellenceCenters", value: excellenceCenterId });

        for (let supportCenterId of approvalsSearch.supportCenters)
            keyValueParams.push({ key: "supportCenters", value: supportCenterId });

        keyValueParams.push({key:"byProject",value:approvalsSearch.byProject})

        builder.addQueryStringParamsInsideFilter(keyValueParams);

        var response = await this.httpClient.get(builder.buildUrl(`${this.endPoint}`));

        approvalsSearch.totalItems = response.totalItems;
        approvalsSearch.totalValue = response.totalValue;

        return response.approvals.map(approval => {
            return new Approval(approval);
        });
    }

    async getAll(
        currentPage: number,
        limit: number
    ): Promise<Result<Array<Approval>>> {
        const builder = new UrlBuilder([
            { key: "skip", value: currentPage },
            { key: "limit", value: limit }
        ]);
        const res = await this.httpClient.get(
            builder.buildUrl(`${this.endPoint}`)
        );

        return new Result<Array<Approval>>(res.approvals, {
            totalItems: res.totalItems
        });
    }

    clearMultiApprovals(){
        this.multiApprovals = [];
    }

    async getSapDocNumByApproval(sapDocEntry: String) {
        return await this.httpClient.get(`/purchase-orders/sap/${sapDocEntry}`);
    }

    async sendInvoiceRequestEmail(approval: Approval): Promise<any> {
        try {
            return await this.httpClient.post(`${this.endPoint}/sendEmail`, approval);
        } catch (error) {
            return error
        }
    }

    async convertApprovalsCsvToJson(file: File, shouldOverrideValues = false): Promise<any> {
        let data: FormData = new FormData();
        data.append('file', file, file.name);
        return await this.httpClient.postFile(`/upload-file/approval`, data, String(shouldOverrideValues));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/approval.service.ts